require("core-js/modules/esnext.global-this.js");

function e(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function t(e) {
  return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

!function (e, n) {
  "object" === ("undefined" == typeof exports ? "undefined" : t(exports)) && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (e = "undefined" != typeof globalThis ? globalThis : e || self).typer = n();
}(this, function () {
  "use strict";

  var t = function e(t) {
    return t ? (t ^ 16 * Math.random() >> t / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, e);
  },
      n = ["typer", "cursor-block", "cursor-soft", "cursor-hard", "no-cursor"],
      r = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890!@$^*()";

  return function (i, o) {
    var u = [],
        a = document.body,
        l = {},
        c = 0;
    if ("String" === d(i) && (i = document.querySelector(i)), i.getAttribute("data-typer")) throw new Error("You've already called Typer on this element.");
    o = p(o), u.speedSet = !0, u.voids = ["AREA", "BASE", "BR", "COL", "COMMAND", "EMBED", "HR", "IMG", "INPUT", "KEYGEN", "LINK", "META", "PARAM", "SOURCE", "TRACK", "WBR"], u.classNames = n, u.id = t(), i.setAttribute("data-typer", u.id);
    var s = {
      cursor: function cursor() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        if (u.cursorRan) return this;
        if (u.cursorRan = !0, !1 === e) return u.cursor = "no-cursor", this;
        var t = e.color,
            n = e.blink,
            r = e.block,
            i = [];
        return t && y('[data-typer="'.concat(u.id, '"] .typer::after'), "background-color:".concat(t)), i.push("hard" === n ? "cursor-hard" : "cursor-soft"), !0 === r && i.push("cursor-block"), u.cursor = i.join(" "), this;
      },
      line: function line(e, t) {
        return g("line", e, t), u.typing || (u.typing = !0, w()), this;
      },
      continue: function _continue(e, t) {
        return g("continue", e, t), this;
      },
      military: function military(e, t) {
        return g("military", e, t), u.typing || (u.typing = !0, w()), this;
      },
      pause: function pause(e) {
        return u.push({
          pause: +e || 500
        }), this;
      },
      emit: function emit(e, t) {
        return t ? "String" === d(t) && (t = document.querySelector(t)) : t = a, u.push({
          emit: e,
          el: t
        }), this;
      },
      listen: function listen(e, t) {
        return t ? "String" === d(t) && (t = document.querySelector(t)) : t = a, u.push({
          listen: e,
          el: t
        }), this;
      },
      back: function back(e, t) {
        return u.push({
          back: e,
          speed: t
        }), this;
      },
      empty: function empty() {
        return u.push({
          empty: !0
        }), this;
      },
      run: function run(e) {
        return u.push({
          run: e
        }), this;
      },
      end: function end(e, t) {
        return u.push({
          end: !0
        }), u.cb = function () {
          return v(e, t);
        }, L("end");
      },
      halt: function halt() {
        if (!u.typing) return this;
        u.halt = !0;
      },
      resume: function resume() {
        if (!u.typing) return this;
        u.complete || (u.halt = !1, u.resume(), u.resume = null);
      },
      repeat: function repeat(e, t) {
        return u.push({
          repeat: !0,
          num: e,
          shouldEmpty: t,
          id: c++
        }), this;
      },
      kill: E
    };

    function f(e) {
      return {}.toString.call(e).slice(8, -1);
    }

    function d(e) {
      var t = f(e);
      if ("html" !== t.slice(0, 4).toLowerCase() && "String" !== t) throw "You need to provide a string selector, such as '.some-class', or an html element.";
      return t;
    }

    function p(e) {
      var t = f(e);
      if (void 0 === e) return u.speedSet ? o : 70;
      if ("Number" === t && !isNaN(e)) return e;

      if ("Object" === t) {
        var n = e.hasOwnProperty("min"),
            r = e.hasOwnProperty("max"),
            i = e.hasOwnProperty("speed");
        if (i && !isNaN(e.speed)) return e.speed;
        if (n && r && e.min < e.max) return e;
        if (!Object.keys(e).length && u.speedSet) return o;
        if (!n && !r && !i) return o;
      }

      throw new Error("You have provided an invalid value for speed.");
    }

    function m(e) {
      if (!e) return null;
      if (+e) return {
        speed: +e,
        chars: 3
      };
      if ("Object" === f(e)) return {
        speed: +e.speed || 50,
        chars: +e.chars || 3
      };
      throw new Error("You have provided an invalid value for military.");
    }

    function v(e, t) {
      u.style && u.style.remove(), u.newDiv && h(), i.removeAttribute("data-typer"), a.removeEventListener("killTyper", E), u.newDiv && u.newDiv.classList.add("white-space"), u.newDiv = "", "function" == typeof e ? e(i) : "function" == typeof t && t(i), !0 !== e && !0 !== t || a.dispatchEvent(new Event("typerFinished"));
    }

    function h() {
      n.forEach(function (e) {
        return u.newDiv.classList.remove(e);
      });
    }

    function y(e, t) {
      u.style = document.createElement("style"), u.style.appendChild(document.createTextNode("")), document.head.appendChild(u.style);
      var n = document.styleSheets[document.styleSheets.length - 1];
      "insertRule" in n ? n.insertRule("".concat(e, "{").concat(t, "}"), 0) : n.addRule(e, t);
    }

    function g(t, n, r) {
      var i = "line" === t,
          o = "continue" === t;
      if (n || r) {
        if ("Object" === f(n)) (i || o && n.container) && u.push(l(n));else if (isNaN(r)) u.push(l(r, n));else {
          var a;
          u.push((e(a = {}, t, n), e(a, "speed", p(r)), e(a, "html", !0), a));
        }
      } else i && u.push({
        line: 1
      });

      function l() {
        var n,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            o = arguments.length > 1 ? arguments[1] : void 0,
            u = r.container,
            a = r.totalTime,
            l = r.military,
            c = !o && ("String" === f(u) ? document.querySelector(u).textContent : u.textContent);
        return e(n = {}, t, o || c), e(n, "speed", p(r)), e(n, "html", !1 !== r.html), e(n, "element", i ? r.element : null), e(n, "military", m(l)), e(n, "totalTime", a), n;
      }
    }

    function w() {
      if (u.item >= 0 || (u.item = 0), u.item === u.length) return u.complete = !0, a.removeEventListener("killTyper", E);
      u.ks || (u.ks = !0, a.addEventListener("killTyper", E)), u.cursor || (u.cursor = "cursor-soft"), u.type = setInterval(function () {
        if (!u.length) return clearInterval(u.type);
        var e,
            t = u[u.item];
        t.line ? T(t) : t.continue ? function (e) {
          clearInterval(u.type), N(e);
        }(t) : t.pause ? function (e) {
          clearInterval(u.type), u.pause = setTimeout(function () {
            u.pause = null, u.item++, w();
          }, e.pause);
        }(t) : t.emit ? function (e) {
          clearInterval(u.type), e.el.dispatchEvent(new Event(e.emit)), u.item++, w();
        }(t) : t.listen ? function (e) {
          var t = e.el,
              n = e.listen;

          function r(e) {
            u.listening = !1, t.removeEventListener(e.type, r), u.killed || (u.item++, w());
          }

          clearInterval(u.type), u.listening = !0, t.addEventListener(n, r), l = {
            el: t,
            type: n,
            fxn: r
          };
        }(t) : t.back ? function (e) {
          var t = e.back,
              n = e.speed;
          if (clearInterval(u.type), !u.newDiv || !u.newDiv.textContent) return u.item++, w();

          var r = function e(t) {
            var n = 0;
            return Array.from(t.childNodes).forEach(function (t) {
              u.voids.includes(t.nodeName) && n++, t.childNodes.length && (n += e(t));
            }), n;
          }(u.newDiv),
              i = u.newDiv.textContent.length;

          if ("empty" === t) {
            if (!n || n >= i) u.newDiv.innerHTML = "";else {
              var a = u.newDiv.cloneNode(!0),
                  l = s(a);
              n < 0 && (n += i);

              for (var c = 0; c < n; c++) {
                l();
              }

              d(a), u.newDiv.innerHTML = a.innerHTML;
            }
            return u.item++, w();
          }

          function s(e) {
            var r = 0,
                i = f(e || u.newDiv).reverse();
            return function a() {
              if (u.halt) return u.resume = function () {
                return u.goBack = setInterval(a, n || o);
              }, clearInterval(u.goBack);
              var l = i[0];
              u.voids.includes(l.nodeName) ? (l.remove(), i.shift()) : (l.textContent = l.textContent.slice(0, -1), l.length || i.shift()), e || ++r === t && (clearInterval(u.goBack), d(u.newDiv), u.item++, w());
            };
          }

          function f(e) {
            var t = [],
                n = Array.from(e.childNodes);
            return n.length ? (n.forEach(function (e) {
              e.childNodes.length ? t = t.concat(f(e)) : t.push(e);
            }), t) : t;
          }

          function d(e) {
            Array.from(e.childNodes).forEach(function (e) {
              u.voids.includes(e.nodeName) || (e.childNodes.length && d(e), "#text" === e.nodeName || e.innerHTML.length || e.remove(), "#text" !== e.nodeName || e.length || e.remove());
            });
          }

          t > i + r && (t = "all"), "all" === t && (t = i + r), t < 0 && (t = i + r - -1 * t), u.goBack = setInterval(s(), n || o);
        }(t) : t.empty ? (i.innerHTML = "", T({
          line: 1
        })) : t.run ? (e = t.run, clearInterval(u.type), e(i), u.item++, w()) : t.repeat ? function (e) {
          if (clearInterval(u.type), e.shouldEmpty && (i.innerHTML = ""), e.num) {
            e.num--;
            var t = u.findIndex(function (t) {
              var n = t.repeat,
                  r = t.id;
              return n && r === e.id - 1;
            }) + 1;
            u.item = t;
          } else u.item++;

          w();
        }(t) : t.end && (clearInterval(u.type), u.cb());
      }, 0);
    }

    function T(e) {
      clearInterval(u.type), u.newDiv && (h(), u.newDiv.classList.add("white-space"), u.newDiv.innerHTML || (u.newDiv.innerHTML = " "));
      var t = document.createElement(e.element || "div");
      if (t.setAttribute("data-typer-child", u.id), t.className = "".concat(u.cursor, " typer white-space"), i.appendChild(t), u.newDiv = t, 1 === e.line) return u.item++, w();
      N(e);
    }

    function b(e, t) {
      var n,
          r,
          i = "Object" === f(e) ? (n = e.min, r = e.max, Math.floor(Math.random() * (r - n + 1) + n)) : e;
      u.halt ? u.resume = function () {
        return u.iterator = setTimeout(t, i);
      } : u.iterator = setTimeout(t, i);
    }

    function N(e) {
      var t,
          n,
          i = e.line || e.continue,
          o = document.createElement("div");
      if (Array.isArray(i)) return t = 0, void b(n = e.totalTime ? e.totalTime / i.length : e.speed, function r() {
        var a = i[t++];
        o.textContent = a, u.newDiv.innerHTML += e.html ? a : o.innerHTML, t === i.length ? s() : b(n, r);
      });

      function a(e, t) {
        var n = [];
        e = Array.from(e);

        for (var r = 0; r < e.length; r++) {
          var i = e[r],
              o = i.nodeName;
          "#text" === o ? n.push({
            parent: t,
            content: i.textContent
          }) : i.childNodes.length ? function () {
            var e = document.createElement(o);
            Array.from(i.attributes).forEach(function (t) {
              e.setAttribute(t.name, t.value);
            }), n.push({
              parent: t,
              newNode: e
            }), n = n.concat(a(i.childNodes, e));
          }() : u.voids.includes(o) && n.push({
            parent: t,
            voidNode: i
          });
        }

        return n;
      }

      function l() {
        return r[Math.floor(Math.random() * r.length)];
      }

      function c(t, n, r) {
        var i = 0,
            o = e.military,
            a = o.speed,
            c = o.chars;
        t.innerHTML += l(), u.military = setInterval(function () {
          if (i === c) return t.innerHTML = t.innerHTML.slice(0, -1) + n, clearInterval(u.military), r();
          t.innerHTML = t.innerHTML.slice(0, -1) + l(), i++;
        }, a);
      }

      function s() {
        return clearInterval(u.iterator), u.item++, w();
      }

      o.innerHTML = i, e.html ? function () {
        var t = a(o.childNodes, u.newDiv),
            n = 0,
            r = 0,
            i = t[n++],
            l = e.totalTime ? e.totalTime / i.content.length : e.speed;
        b(l, function o() {
          if (i.content && r === i.content.length && (r = 0, i = t[n++]), !i) return s();

          if (i.content) {
            if (e.military) return c(i.parent, i.content[r++], function () {
              b(l, o);
            });
            i.parent.innerHTML += i.content[r++];
          } else i.parent.appendChild(i.voidNode || i.newNode), i = t[n++];

          b(l, o);
        });
      }() : function () {
        var t = 0,
            n = e.totalTime ? e.totalTime / i.length : e.speed;
        b(n, function r() {
          if (t === i.length) return s();
          var a = i[t];
          if (e.military) return c(u.newDiv, a, function () {
            t++, b(n, r);
          });
          "String" !== f(i) && (o.textContent = a, a = o.innerHTML), u.newDiv.innerHTML += a, t++, b(n, r);
        });
      }();
    }

    function E() {
      return u.typing ? (l.el && l.el.removeEventListener(l.type, l.fxn), clearInterval(u.type), clearInterval(u.iterator), clearInterval(u.goBack), clearInterval(u.military), clearTimeout(u.pause), v(), L("kill")) : s;
    }

    function L(e) {
      var t = function t() {
        return s;
      };

      return Object.keys(s).forEach(function (n) {
        "end" === e && "kill" === n || (s[n] = t);
      }), "kill" === e && (u.killed = !0), s;
    }

    return s;
  };
});